import {
  ANALYTICS_COLOR_1,
  ANALYTICS_COLOR_2,
  ANALYTICS_COLOR_3,
  ANALYTICS_COLOR_POSTS,
  ANALYTICS_COLOR_YELLOW,
  LINKEDIN_BUSINESS_PAGE
} from '../../../config/constants';
import {
  METRIC_LINKEDIN_BUSINESS_PAGE_ALL_PAGE_VIEWS_PAGE_VIEWS,
  METRIC_LINKEDIN_BUSINESS_PAGE_ALL_PAGE_VIEWS_UNIQUE_PAGE_VIEWS,
  METRIC_LINKEDIN_BUSINESS_PAGE_CUMULATED_COMMENTS,
  METRIC_LINKEDIN_BUSINESS_PAGE_CUMULATED_IMPRESSIONS,
  METRIC_LINKEDIN_BUSINESS_PAGE_CUMULATED_REACTIONS,
  METRIC_LINKEDIN_BUSINESS_PAGE_CUMULATED_SHARES,
  METRIC_LINKEDIN_BUSINESS_PAGE_CUMULATED_VIDEO_VIEWS,
  METRIC_LINKEDIN_BUSINESS_PAGE_TOTAL_LIKES,
  METRIC_LINKEDIN_PERSONAL_ACCOUNT_CUMULATED_SHARES
} from '../../../config/metrics';
import { displayFunctions } from '../../../utils/chartsUtils';
import {
  DEMO_DATA_LINKEDIN_INTERACTIONS_REACTIONS,
  DEMO_DATA_LINKEDIN_INTERACTIONS_SHARES,
  DEMO_DATA_LINKEDIN_OVERVIEW_FOLLOWERS,
  DEMO_DATA_LINKEDIN_OVERVIEW_REACH,
  DEMO_DATA_LINKEDIN_OVERVIEW_VIEWS,
  DEMO_DATA_LINKEDIN_SUMMARY_IMPRESSIONS,
  DEMO_DATA_LINKEDIN_SUMMARY_INTERACTIONS
} from '../../../utils/demoDataUtils/demoDataArrays';
import { getStaticDataPoints } from '../../../utils/demoDataUtils/demoDataFunctions';

const filters = {
  filters: []
};

export const growthConfig: any = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //     title: 'posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     platform: LINKEDIN_BUSINESS_PAGE,
  //     type: 'bar'
  // },

  metrics: [
    {
      metrics: [METRIC_LINKEDIN_BUSINESS_PAGE_TOTAL_LIKES],
      title: 'followers',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      platform: LINKEDIN_BUSINESS_PAGE,
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_LINKEDIN_OVERVIEW_FOLLOWERS
        }
      }
    },
    {
      metrics: [METRIC_LINKEDIN_BUSINESS_PAGE_ALL_PAGE_VIEWS_PAGE_VIEWS],
      title: 'views',
      iconCssClass: 'optional value',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      platform: LINKEDIN_BUSINESS_PAGE,
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_LINKEDIN_OVERVIEW_VIEWS
        }
      }
    },
    {
      metrics: [METRIC_LINKEDIN_BUSINESS_PAGE_ALL_PAGE_VIEWS_UNIQUE_PAGE_VIEWS],
      title: 'reach',
      iconCssClass: 'optional value',
      hexColor: ANALYTICS_COLOR_3,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      platform: LINKEDIN_BUSINESS_PAGE,
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_LINKEDIN_OVERVIEW_REACH
        }
      }
    }
  ]
};
export const likesDevelopmentConfig = {
  shouldBeCached: false,
  ...filters,
  no_data_available: 'no_data_available',
  metrics: [
    {
      metrics: [METRIC_LINKEDIN_BUSINESS_PAGE_TOTAL_LIKES],
      title: 'likes',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'bar',
      formula: 'delta',
      display: 'max'
    }
  ]
};

const summaryConfig = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //     title: 'posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar'
  // },

  metrics: [
    {
      metrics: [604, 605, 606, 607, 608, 609],
      title: 'interactions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_LINKEDIN_SUMMARY_INTERACTIONS
        }
      }
    },
    {
      metrics: [613],
      title: 'impressions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_3,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_LINKEDIN_SUMMARY_IMPRESSIONS
        }
      }
    }
  ]
};

const interactionsConfig = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //     title: 'posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar'
  // },

  metrics: [
    {
      metrics: [604, 605, 606, 607, 608, 609],
      title: 'reactions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_LINKEDIN_INTERACTIONS_REACTIONS
        }
      }
    },
    {
      metrics: [601],
      title: 'comments',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: [0, 0, 0, 0, 0, 0, 0, 0]
        }
      }
    },
    {
      metrics: [610],
      title: 'shares',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_3,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_LINKEDIN_INTERACTIONS_SHARES
        }
      }
    }
  ]
};
export const postsConfig = {
  summary: summaryConfig,
  interactions: interactionsConfig
};

// --------------------------------------------------------------
export const impressions = {
  addAdditionalPlots: false,

  impressions: {
    title: 'mixedChart.impressions',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  }
};

export const followers = {
  addAdditionalPlots: true,

  followers: {
    title: 'mixedChart.followers',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.lastValue
  },
  paid_followers: {
    title: 'mixedChart.paid_followers',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',

    display: displayFunctions.lastValue
  },
  organic_followers: {
    title: 'mixedChart.organic_followers',
    hexColor: ANALYTICS_COLOR_3,
    type: 'line',

    display: displayFunctions.lastValue
  }
};

export const followerDevelopment = {
  addAdditionalPlots: false,

  new_followers: {
    title: 'mixedChart.new_followers',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.lastValue
  }
};

export const pageViews = {
  addAdditionalPlots: false,

  page_views: {
    title: 'mixedChart.page_views',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  },
  unique_page_views: {
    title: 'mixedChart.unique_page_views',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',

    display: displayFunctions.sum
  }
};

export const newConfigsMap: any = {
  impressions,
  followers,
  follower_development: followerDevelopment,
  page_views: pageViews,
  posts_per_day: {
    normalizeValues: true,
    title: 'mixedChart.posts_per_day',
    hexColor: ANALYTICS_COLOR_POSTS,
    type: 'bar',
    display: displayFunctions.sum,
    additionalPlot: true
  }
};
